import { Box, Paper, IconButton, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Fixierte Eingabeleiste zum Schreiben eines Kommentars.
function KommentarInput({ value, onChange, onSubmit, onBack }) {
    return (
        <Box sx={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            height: "75px",
            bgcolor: "background.default",
        }}>
            <Paper
                component="form"
                onSubmit={onSubmit}
                elevation={3}
                sx={{
                    position: "fixed",
                    bottom: { xs: 12, md: 0 },
                    left: 0,
                    right: 0,
                    p: 1.5,
                    mx: { xs: 1, sm: "auto" },
                    maxWidth: { xs: "calc(100% - 16px)", sm: 600 },
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    background: "linear-gradient(145deg, #1e293b 0%, #0f172a 100%)",
                    border: "1px solid rgba(59, 130, 246, 0.3)",
                    borderRadius: "24px",
                    zIndex: 999,
                }}
            >
                <IconButton onClick={onBack}><ArrowBackIcon /></IconButton>
                <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Nachricht schreiben..."
                    value={value}
                    onChange={onChange}
                    multiline
                    maxRows={4}
                    slotProps={{ htmlInput: { maxLength: 1000 } }}
                    InputProps={{
                        disableUnderline: true,
                        sx: {
                            color: "#e0f2fe",
                            fontSize: "0.95rem",
                            px: 1,
                        },
                    }}
                    sx={{
                        "& .MuiInputBase-input::placeholder": {
                            color: "#64748b",
                            opacity: 1,
                        },
                    }}
                />
                <IconButton
                    type="submit"
                    disabled={!value.trim()}
                    sx={{
                        bgcolor: "#3b82f6",
                        color: "#fff",
                        width: 40,
                        height: 40,
                        "&:hover": {
                            bgcolor: "#2563eb",
                        },
                        "&:disabled": {
                            bgcolor: "#334155",
                            color: "#64748b",
                        },
                    }}
                >
                    <SendIcon sx={{ fontSize: "1.2rem" }} />
                </IconButton>
            </Paper>
        </Box>
    );
}

export default KommentarInput;
